import BaseService from "../base.service";

class IndividualObjectivePeriod extends BaseService {
  constructor() {
    super("individual-objective-period");
  }
}

export default new IndividualObjectivePeriod();
